import { render } from "./SubNavbar.vue?vue&type=template&id=1d9d7a19"
import script from "./SubNavbar.vue?vue&type=script&lang=js"
export * from "./SubNavbar.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__